import { Store } from "pullstate";
import User from "../../user";

export const UserStore = new Store({
    user: User,
    global:null,
  });

